/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */
import type { ErrorInfo } from 'react';

import { type CreateUIAnalyticsEvent, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { unimplementedAbstractService } from '../../core/utils';

// A service with a default implementation (an override can still be provided, optionally):
export const getStargateURL = (url: `/${string}`) => `/gateway/api${url}`;

// An abstract service that should always be provided:
export const getCurrentCloudId = unimplementedAbstractService<() => string>('getCurrentCloudId');

export const getCurrentUserId = unimplementedAbstractService<() => string>('getCurrentUserId');
export type Product =
	| 'confluence'
	| 'jira'
	| 'jira-software'
	| 'jira-servicedesk'
	| 'jira-core'
	| 'jira-product-discovery'
	| 'loom'
	| 'trello'
	| 'bitbucket'
	| 'statuspage'
	| 'opsgenie'
	| 'townsquare' // Atlas
	| 'compass'
	| 'avp'; // Atlassian analytics
export const getCurrentProduct = unimplementedAbstractService<() => Product>('getCurrentProduct');
export const createAnalyticsEvent =
	unimplementedAbstractService<CreateUIAnalyticsEvent>('createAnalyticsEvent');
export type AnalyticsMeta = {
	id: string;
	packageName?: string;
	teamName?: string;
};
export type AnalyticsAttributes = {
	[key: string]:
		| boolean
		| string
		| number
		| AnalyticsAttributes
		| AnalyticsAttributes[]
		| undefined
		| null;
};
export type AnalyticsPayload = {
	event?: UIAnalyticsEvent;
	error?: Error;
	errorInfo?: ErrorInfo;
	meta: AnalyticsMeta;
	attributes?: AnalyticsAttributes;
	sendToPrivacyUnsafeSplunk?: boolean;
	skipSentry?: boolean;
};
export const fireErrorAnalytics =
	unimplementedAbstractService<AnalyticsPayload>('fireErrorAnalytics');
